import loadable from '@loadable/component';

export const SavodSelection = loadable(() => import('./SavodSelection'));
